export default __webpack_public_path__ + "static/mokuCircle-f715241adf8c2c0e7e6324b621111281.svg";